import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

const pathMap = {
	[Locale.cs]: "/kosik" as const,
	[Locale.en]: "/cart" as const,
} satisfies LocalizedString;

export function getCartPath(tenant: Tenant): string {
	return getPathInLocale(tenant.locale, pathMap);
}
